<div class="eci-shell">
  <div class="container">

    <!-- HEADER CARD -->
    <div class="header-card">
      <!-- Linha 1: Voltar + número do pedido -->
      <div class="hc-top">
        <button class="btn-voltar" (click)="onVoltar()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          Voltar
        </button>
        <div class="hc-top-right">
          <span class="hc-badge">#{{ nunota }}</span>
          <span class="hc-tag-badge" *ngIf="numTag" title="Nº da TAG informado na Separação">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.24H4a1 1 0 0 0-1 1v5.59a2 2 0 0 0 .59 1.41l9.58 9.59a2 2 0 0 0 2.82 0l4.6-4.6a2 2 0 0 0 0-2.82z"></path><circle cx="7.5" cy="7.5" r="1.5"></circle></svg>
            TAG {{ numTag }}
          </span>
        </div>
      </div>

      <!-- Linha 2: Cliente -->
      <div class="hc-info">
        <div class="hc-cliente" *ngIf="clienteNome">{{ clienteNome }}</div>
        <div class="hc-vendedor" *ngIf="vendedor">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          {{ vendedor }}
        </div>
        <div class="hc-obs-entrega" *ngIf="obsEntrega">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3h5v5"></path><path d="M8 3H3v5"></path><path d="M3 16v5h5"></path><path d="M21 16v5h-5"></path></svg>
          <div>
            <strong>Observação de Entrega:</strong>
            <span>{{ obsEntrega }}</span>
          </div>
        </div>
      </div>

      <!-- Linha 3: Ações -->
      <div class="hc-acoes">
        <button class="btn-pendencia"
            [disabled]="!temItensPendentesOuDivergentes || enviandoPendencia || finalizando"
            (click)="abrirModalPendencia()"
            title="Enviar itens pendentes ou divergentes ao vendedor para ajuste"><app-loading-indicator *ngIf="enviandoPendencia" size="inline"></app-loading-indicator>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
          {{ enviandoPendencia ? 'Enviando...' : 'Enviar ao Vendedor' }}
        </button>
        <button class="btn-finalizar"
            [disabled]="!allDone || finalizando || finalizandoClienteRetira"
            (click)="finalizar()">
          <svg *ngIf="!finalizando" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          {{ finalizando ? 'Finalizando...' : 'Finalizar' }}
        </button>
        <button class="btn-cliente-retira"
            [disabled]="!allDone || finalizando || finalizandoClienteRetira"
            (click)="abrirModalClienteRetira()"
            title="Cliente retira — finaliza sem passar pela logística">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 9v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9"></path><path d="M9 22V12h6v10"></path><path d="M2 10.6L12 2l10 8.6"></path></svg>
          {{ finalizandoClienteRetira ? 'Finalizando...' : 'Cliente Retira' }}
        </button>
        <button class="btn-transferir" (click)="abrirModalTransferir()" title="Transferir conferência para outro conferente">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
          Transferir
        </button>
      </div>
    </div>

    <!-- STATES -->
    <div *ngIf="carregando" class="loading-state">
      <app-loading-indicator></app-loading-indicator>
      <span>Carregando itens...</span>
    </div>

    <div *ngIf="erro && !carregando" class="alert-danger" style="margin-bottom:12px">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erro }}
    </div>

    <div *ngIf="erroSalvar" class="alert-danger" style="margin-bottom:12px">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erroSalvar }}
    </div>

    <div *ngIf="erroPendencia" class="alert-danger" style="margin-bottom:12px">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erroPendencia }}
    </div>

    <div *ngIf="erroFinalizar" class="alert-danger" style="margin-bottom:12px">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erroFinalizar }}
    </div>

    <div *ngIf="erroClienteRetira" class="alert-danger" style="margin-bottom:12px">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erroClienteRetira }}
    </div>

    <!-- CONTENT CARD -->
    <div class="content-card" *ngIf="!carregando && !erro">

      <!-- Progress -->
      <div class="progress-bar-container">
        <div class="progress-info">
          <span>Progresso ({{ itensConferidosLista.length }}/{{ itens.length }})</span>
          <span>{{ progresso }}%</span>
        </div>
        <div class="progress-bg">
          <div class="progress-fill" [style.width]="progresso + '%'"></div>
        </div>
      </div>

      <!-- Abas -->
      <div class="abas-wrap">
        <button class="aba-btn" [class.ativa]="abaAtiva === 'pendentes'" (click)="abaAtiva = 'pendentes'">
          A Conferir
          <span class="aba-count" [class.count-alert]="itensPendentes.length > 0">{{ itensPendentes.length }}</span>
        </button>
        <button class="aba-btn" [class.ativa]="abaAtiva === 'conferidos'" (click)="abaAtiva = 'conferidos'">
          Conferidos
          <span class="aba-count" [class.count-ok]="itensConferidosLista.length > 0">{{ itensConferidosLista.length }}</span>
        </button>
      </div>

      <!-- Aba: A Conferir (conferência cega por busca de PN/código) -->
      <div class="itens-list" *ngIf="abaAtiva === 'pendentes'">
        <div class="empty-aba" *ngIf="itensPendentes.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          Todos os itens foram conferidos!
        </div>

        <!-- CONFERÊNCIA CEGA por busca: só aparece o item depois que o
             conferente digita o código/PN — a lista inteira de pendentes
             nunca fica visível de uma vez. -->
        <div class="busca-pn-wrap" *ngIf="itensPendentes.length > 0">
          <label class="busca-pn-label">Código / PN do produto</label>
          <div class="input-busca-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            <input #buscaPnInput type="text"
              [(ngModel)]="buscaPn"
              (ngModelChange)="onBuscaPnChange()"
              placeholder="Digite o código ou a referência do fornecedor..."
              autocomplete="off">
          </div>

          <!-- Item encontrado (match único) -->
          <div class="item-card item-card--busca" *ngIf="itemBuscaAtual as item">
            <div class="item-details">
              <div class="item-title-row">
                <h4>{{ item.descricao }}</h4>
                <span class="item-pn" *ngIf="item.refforn || item.condicao || item.codprod">
                  <span class="pn-label" *ngIf="item.refforn">P/N</span>
                  <span *ngIf="item.refforn">{{ item.refforn }}</span>
                  <span class="pn-sep" *ngIf="item.refforn && item.condicao"> · </span>
                  <span class="pn-label" *ngIf="item.condicao">CD</span>
                  <span *ngIf="item.condicao">{{ item.condicao }}</span>
                  <span class="pn-sep"> · </span>
                  <span class="pn-label">COD</span>
                  <span>{{ item.codprod }}</span>
                </span>
              </div>
              <div class="item-meta">
                <span class="badge loc" *ngIf="item.local">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                  {{ item.local }}
                </span>
                <span class="badge ref" *ngIf="item.condicao">{{ item.condicao }}</span>
              </div>

              <!-- Contagem cega -->
              <div class="item-contagem-wrap">
                <input #qtdContadaInput class="input-qtd-contada" type="text" inputmode="decimal"
                  [(ngModel)]="item.qtdConferidaStr"
                  placeholder="Qtd. contada"
                  (keydown.enter)="confirmarContagemBusca(item)">
                <span class="item-unidade-contagem">{{ item.unidade }}</span>
                <button class="btn-conferir" (click)="confirmarContagemBusca(item)" title="Confirmar contagem">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  Confirmar
                </button>
              </div>

              <!-- "Item no outro Galpão" -- sinaliza pendência sem travar a conferência cega. -->
              <button class="btn-item-outro-galpao" (click)="abrirModalPendenciaGalpao(item, $event)" title="Sinalizar que este item está no outro galpão">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                Item no outro Galpão
              </button>

              <!-- Observação -->
              <div class="item-obs-wrap">
                <button class="btn-obs-toggle" (click)="toggleObs(item)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                  {{ obsEditando.has(item.seq) ? 'Fechar obs.' : (item.observacao ? 'Ver obs.' : 'Adicionar obs.') }}
                </button>
                <div class="obs-input-wrap" *ngIf="obsEditando.has(item.seq)">
                  <textarea class="obs-textarea" [(ngModel)]="item.observacao"
                    placeholder="Observação de divergência..."
                    rows="2"
                    (blur)="salvarObservacao(item)"></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Vários candidatos — pede pra desambiguar. Quando o mesmo produto
               aparece em mais de uma linha pendente (duplicado no pedido), código
               e PN são idênticos nos dois — mostra local/condição/sequência pra
               dar pro conferente como diferenciar qual linha é qual. -->
          <div class="sugestoes sugestoes-pn" *ngIf="!itemBuscaAtual && itensBuscaMultiplos.length > 0">
            <div class="sugestao-item" *ngFor="let c of itensBuscaMultiplos" (click)="selecionarCandidatoPn(c)">
              <span class="item-cod-mono">{{ c.codprod }}</span>
              <span class="pn-sep" *ngIf="c.refforn"> · </span>
              <span class="item-ref-mono" *ngIf="c.refforn">{{ c.refforn }}</span>
              <span class="sugestao-desc">{{ c.descricao }}</span>
              <span class="sugestao-diferenciador" *ngIf="candidatoTemDuplicata(c)" title="Produto duplicado no pedido — confira local/condição antes de escolher">
                Item #{{ c.seq }}
                <ng-container *ngIf="c.local"> · {{ c.local }}</ng-container>
                <ng-container *ngIf="c.condicao"> · CD {{ c.condicao }}</ng-container>
              </span>
            </div>
          </div>

          <!-- Nenhum resultado -->
          <div class="pn-sem-resultado" *ngIf="!itemBuscaAtual && itensBuscaMultiplos.length === 0 && buscaPn.trim()">
            Nenhum item pendente encontrado para "{{ buscaPn }}".
          </div>

          <!-- Nada digitado ainda -->
          <div class="pn-hint" *ngIf="!buscaPn.trim()">
            {{ itensPendentes.length }} {{ itensPendentes.length === 1 ? 'item pendente' : 'itens pendentes' }} — digite o código ou PN para começar a conferir.
          </div>
        </div>
      </div>

      <!-- Aba: Conferidos -->
      <div class="itens-list" *ngIf="abaAtiva === 'conferidos'">
        <div class="empty-aba" *ngIf="itensConferidosLista.length === 0">
          Nenhum item conferido ainda.
        </div>

        <div class="item-card conferido" [class.divergente]="item.divergente" [class.item-card-pendente]="item.pendente" *ngFor="let item of itensConferidosLista" (click)="!item.pendente && desconferirItem(item)">
          <div class="checkbox-wrapper" *ngIf="!item.pendente">
            <div class="custom-checkbox" [class.checkbox-divergente]="item.divergente">
              <svg *ngIf="!item.divergente" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <svg *ngIf="item.divergente" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4"></path><path d="M12 17h.01"></path><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"></path></svg>
            </div>
          </div>
          <div class="checkbox-wrapper" *ngIf="item.pendente">
            <div class="custom-checkbox-pendente">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
            </div>
          </div>
          <div class="item-details">
            <div class="item-title-row">
              <h4>{{ item.descricao }}</h4>
              <span class="item-pn" *ngIf="item.refforn || item.condicao || item.codprod">
                <span class="pn-label" *ngIf="item.refforn">P/N</span>
                <span *ngIf="item.refforn">{{ item.refforn }}</span>
                <span class="pn-sep" *ngIf="item.refforn && item.condicao"> · </span>
                <span class="pn-label" *ngIf="item.condicao">CD</span>
                <span *ngIf="item.condicao">{{ item.condicao }}</span>
                <span class="pn-sep"> · </span>
                <span class="pn-label">COD</span>
                <span>{{ item.codprod }}</span>
              </span>
            </div>
            <div class="item-meta" *ngIf="!item.pendente">
              <span class="badge qty" *ngIf="!item.divergente">{{ item.qtd | number:'1.0-2' }} {{ item.unidade }}</span>
              <span class="badge qty-divergente" *ngIf="item.divergente">
                Contado {{ formatarQtd(item.qtdConferida) }} / Esperado {{ item.qtd | number:'1.0-2' }} {{ item.unidade }}
              </span>
              <span class="badge loc" *ngIf="item.local">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                {{ item.local }}
              </span>
            </div>
            <!-- Item pendente ("Item no outro Galpão") -- badge + Desfazer (sinalização feita por engano). -->
            <div class="item-meta" *ngIf="item.pendente" (click)="$event.stopPropagation()">
              <span class="badge pendente-galpao">Aguardando o outro galpão</span>
              <button class="btn-desfazer-pendencia-galpao" (click)="desfazerPendenciaGalpao(item, $event)" [disabled]="desfazendoPendenciaGalpaoSeq === item.seq" title="Desfazer sinalização (feita por engano)">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                {{ desfazendoPendenciaGalpaoSeq === item.seq ? 'Desfazendo...' : 'Desfazer' }}
              </button>
            </div>
            <!-- Observação -->
            <div class="item-obs-wrap" *ngIf="item.observacao || obsEditando.has(item.seq)" (click)="$event.stopPropagation()">
              <button class="btn-obs-toggle" (click)="toggleObs(item)">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                {{ obsEditando.has(item.seq) ? 'Fechar obs.' : 'Ver obs.' }}
              </button>
              <div class="obs-input-wrap" *ngIf="obsEditando.has(item.seq)">
                <textarea class="obs-textarea" [(ngModel)]="item.observacao"
                  placeholder="Observação de divergência..."
                  rows="2"
                  (blur)="salvarObservacao(item)"></textarea>
              </div>
              <div class="obs-preview" *ngIf="!obsEditando.has(item.seq) && item.observacao">
                {{ item.observacao }}
              </div>
            </div>
            <div class="item-obs-wrap" *ngIf="!item.observacao && !obsEditando.has(item.seq)" (click)="$event.stopPropagation()">
              <button class="btn-obs-toggle" (click)="toggleObs(item)">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                Adicionar obs.
              </button>
              <div class="obs-input-wrap" *ngIf="obsEditando.has(item.seq)">
                <textarea class="obs-textarea" [(ngModel)]="item.observacao"
                  placeholder="Observação de divergência..."
                  rows="2"
                  (blur)="salvarObservacao(item)"></textarea>
              </div>
            </div>
          </div>
          <button class="btn-desconferir" *ngIf="!item.pendente" (click)="$event.stopPropagation(); desconferirItem(item)" title="Desmarcar">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- ── MODAL "ITEM NO OUTRO GALPÃO" ─────────────────────────────────────── -->
<!-- Sem identificação de usuário: CODUSU vem da sessão Sankhya já logada. -->
<div class="modal-overlay" *ngIf="modalPendenciaGalpao" (click)="fecharModalPendenciaGalpao()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-3px;margin-right:6px"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
        Item no outro Galpão
      </h2>
      <button class="btn-fechar-modal" (click)="fecharModalPendenciaGalpao()" [disabled]="marcandoPendenteGalpao">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc">
        Este item sai da fila "A Conferir" sem travar a conferência dos demais -- alguém confirma quando trouxer o item na tela global "Itens Pendentes".
      </p>
      <label class="busca-pn-label">Observação (opcional)</label>
      <textarea
        class="id-input"
        rows="3"
        style="resize:vertical"
        [(ngModel)]="pendenciaGalpaoObservacaoRascunho"
        placeholder="Ex.: está no galpão B, prateleira 4"
      ></textarea>
      <div *ngIf="erroPendenciaGalpao" class="alert-danger" style="margin-top:12px">{{ erroPendenciaGalpao }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalPendenciaGalpao()" [disabled]="marcandoPendenteGalpao">Cancelar</button>
      <button class="btn-confirmar-modal" (click)="confirmarPendenciaGalpao()" [disabled]="marcandoPendenteGalpao">
        {{ marcandoPendenteGalpao ? 'Sinalizando...' : 'Confirmar' }}
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL CLIENTE RETIRA ─────────────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalClienteRetira" (click)="fecharModalClienteRetira()">
  <div class="modal-box modal-finalizar" (click)="$event.stopPropagation()">
    <div class="modal-finalizar-body">
      <div class="modal-finalizar-icone modal-finalizar-icone--retira">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 9v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9"></path><path d="M9 22V12h6v10"></path><path d="M2 10.6L12 2l10 8.6"></path></svg>
      </div>
      <h2>Cliente Retira?</h2>
      <p>O pedido <strong>#{{ nunota }}</strong> será finalizado diretamente, sem passar pela etapa de logística. Use esta opção quando o cliente retirar o pedido pessoalmente.</p>
      <div class="modal-finalizar-acoes">
        <button class="btn-cancelar-modal" (click)="fecharModalClienteRetira()">Cancelar</button>
        <button class="btn-concluir-modal btn-concluir-modal--retira" (click)="confirmarClienteRetira()">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          Confirmar — Cliente Retira
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ── MODAL TRANSFERIR CONFERÊNCIA ─────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalTransferir" (click)="fecharModalTransferir()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Transferir Conferência</h2>
      <button class="btn-fechar-modal" (click)="fecharModalTransferir()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>

    <div class="modal-body">
      <p class="modal-desc">
        Selecione o conferente que irá continuar esta conferência. Após transferir, você não terá mais acesso a este pedido.
      </p>

      <!-- Conferente selecionado -->
      <div class="selecionados-list" *ngIf="selecionadoTransferir">
        <div class="chip">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          {{ selecionadoTransferir.nomeusu }}
          <button class="chip-remove" (click)="selecionadoTransferir = null; buscaTransferir = ''">×</button>
        </div>
      </div>

      <!-- Campo de busca -->
      <div class="input-busca-wrap" [class.disabled]="!!selecionadoTransferir">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
        <input
          type="text"
          [(ngModel)]="buscaTransferir"
          (ngModelChange)="onBuscaTransferir()"
          placeholder="Buscar conferente pelo nome..."
          [disabled]="!!selecionadoTransferir"
        />
        <app-loading-indicator *ngIf="buscandoTransferir" size="inline"></app-loading-indicator>
      </div>

      <!-- Sugestões -->
      <div class="sugestoes" *ngIf="usuariosTransferir.length > 0">
        <div class="sugestao-item" *ngFor="let u of usuariosTransferir" (click)="selecionarTransferir(u)">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          {{ u.nomeusu }}
        </div>
      </div>

      <div *ngIf="erroTransferir" class="alert-danger" style="margin-top:12px">{{ erroTransferir }}</div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalTransferir()">Cancelar</button>
      <button class="btn-confirmar-modal btn-confirmar-transferir" (click)="confirmarTransferencia()"
              [disabled]="transferindo || !selecionadoTransferir">
        {{ transferindo ? 'Transferindo...' : 'Confirmar Transferência' }}
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL ENVIAR PENDÊNCIA ───────────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalPendencia" (click)="fecharModalPendencia()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Enviar ao Vendedor?</h2>
      <button class="btn-fechar-modal" (click)="fecharModalPendencia()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc">
        {{ textoItensPendenciaModal }} {{ (itensPendentes.length + itensDivergentes.length) === 1 ? 'será enviado' : 'serão enviados' }} ao vendedor para ajuste. O pedido ficará com status <strong>Pendência Vendedor</strong>.
      </p>
      <label class="busca-pn-label">Observação para o vendedor (obrigatório)</label>
      <textarea class="obs-textarea" [(ngModel)]="obsPendencia"
        placeholder="Descreva o motivo do envio (ex.: item com quantidade divergente, item faltando, etc.)"
        rows="4"></textarea>
      <div *ngIf="erroPendencia" class="alert-danger" style="margin-top:12px">{{ erroPendencia }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalPendencia()">Cancelar</button>
      <button class="btn-confirmar-modal btn-confirmar-modal--warning" (click)="confirmarEnviarPendencia()" [disabled]="!obsPendencia.trim() || enviandoPendencia"><app-loading-indicator *ngIf="enviandoPendencia" size="inline"></app-loading-indicator>
        {{ enviandoPendencia ? 'Enviando...' : 'Confirmar Envio' }}
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL DIVERGÊNCIAS ───────────────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalDivergencias" (click)="deixarDivergenciasPendente()">
  <div class="modal-box modal-divergencias" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Divergências na Conferência</h2>
      <button class="btn-fechar-modal" (click)="deixarDivergenciasPendente()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc">
        {{ itensDivergentes.length }} {{ itensDivergentes.length === 1 ? 'item ficou com quantidade diferente' : 'itens ficaram com quantidade diferente' }} da esperada:
      </p>
      <div class="lista-divergencias">
        <div class="divergencia-row" *ngFor="let item of itensDivergentes">
          <div class="divergencia-info">
            <span class="item-cod-mono">{{ item.codprod }}<span *ngIf="item.refforn"> — {{ item.refforn }}</span></span>
            <span class="divergencia-desc">{{ item.descricao }}</span>
          </div>
          <div class="divergencia-qtds">
            <span class="divergencia-esperado">Esperado: {{ item.qtd | number:'1.0-2' }}</span>
            <span class="divergencia-contado">Contado: {{ formatarQtd(item.qtdConferida) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="deixarDivergenciasPendente()">Deixar Pendente</button>
      <button class="btn-confirmar-modal btn-confirmar-modal--warning" (click)="notificarVendedorDivergencias()">
        Notificar Vendedor
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL FINALIZAR (abre ao marcar o último item, sem divergências) ─── -->
<div class="modal-overlay" *ngIf="modalFinalizar" (click)="modalFinalizar = false">
  <div class="modal-box modal-finalizar" (click)="$event.stopPropagation()">
    <div class="modal-finalizar-body">
      <div class="modal-finalizar-icone">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
      </div>
      <h2>Conferência Completa!</h2>
      <p>Todos os {{ itens.length }} itens foram conferidos. Como deseja finalizar?</p>
      <div class="modal-finalizar-acoes">
        <button class="btn-cancelar-modal" (click)="modalFinalizar = false">Revisar</button>
        <button class="btn-concluir-modal" (click)="finalizarDoModal()" [disabled]="finalizando">
          {{ finalizando ? 'Finalizando...' : 'Finalizar → Logística' }}
        </button>
      </div>
      <div class="modal-separator"><span>ou</span></div>
      <button class="btn-modal-retira-full" (click)="modalFinalizar = false; abrirModalClienteRetira()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 9v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9"></path><path d="M9 22V12h6v10"></path><path d="M2 10.6L12 2l10 8.6"></path></svg>
        Cliente Retira — Finalizar direto
      </button>
    </div>
  </div>
</div>
